import { useState, useEffect, useCallback } from "react";
import { deleteTodoForId, retrieveAllTodosForUsername } from "./api/TodoApiService";
import { useAuth } from "./security/Authcontext";
import "./ListTodospage.css";
import { useNavigate } from "react-router-dom";

function ListTodos() {
  const navigate = useNavigate();
  const [todos, setTodos] = useState([]);
  const [message, setMessage] = useState(null);
  const authContext = useAuth();
  const username = authContext.usrname;

  const refreshTodos = useCallback(() => {
    retrieveAllTodosForUsername(username, authContext.token)
      .then((response) => setTodos(response.data))
      .catch((error) => console.log(error));
  }, [username, authContext.token]);

  useEffect(() => {
    refreshTodos();
  }, [refreshTodos]);

  function deleteTodo(id, description) {
    deleteTodoForId(username, id).then(() => {
      setMessage(`Task "${description}" deleted successfully`);
      refreshTodos();
    });
  }

  return (
    <div className="todos-page">
      <div className="todos-card">
        <div className="todos-header">
          <h1>📋 Your Tasks</h1>
          <button
            className="add-task-btn"
            onClick={() => navigate("/add-todos")}
          >
            + New Task
          </button>
        </div>

        {message && <div className="success-msg">{message}</div>}

        <div className="table-wrapper">
          <table className="todos-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Status</th>
                <th>Target Date</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {todos.map((todo) => (
                <tr key={todo.id}>
                  <td className="desc">{todo.description}</td>

                  <td>
                    <span
                      className={
                        todo.isDone ? "status done" : "status pending"
                      }
                    >
                      {todo.isDone ? "Done" : "Pending"}
                    </span>
                  </td>

                  <td>
                    {new Date(todo.targetDate).toLocaleDateString()}
                  </td>

                  <td className="actions">
                    <button
                      className="icon-btn edit"
                      onClick={() =>
                        navigate(`/list-todos/${todo.id}`)
                      }
                    >
                      ✏️
                    </button>
                    <button
                      className="icon-btn delete"
                      onClick={() =>
                        deleteTodo(todo.id, todo.description)
                      }
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {todos.length === 0 && (
            <div className="empty-state">
              <p>No tasks yet</p>
              <button onClick={() => navigate("/add-todos")}>
                Create your first task
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ListTodos;
